import type { PriceResultsMoreFromSource } from '@/pages/Item/helpers/getPriceResultsMoreFromSource';
import type { ExcludedFacets } from '@/redux/modules/search/exclusions/searchExclusions.types';

import { fetchCategoryResults } from '@/redux/modules/search/search.api';
import { getAugmentedSearchQuery } from '@/redux/modules/search/search.helpers';
import FacetTypes from '@/types/search/enums/facetTypes';
import { buildSearchQuery } from '@/utils/search/searchQuery';

import { MORE_FROM_LIMIT } from './priceResultsMoreFrom.types';

type FetchPriceResultsMoreFromCategoryParams = {
    authToken: string;
    deployment: string;
    excludedFacets: ExcludedFacets;
    ipAddress: string;
    source: PriceResultsMoreFromSource;
    useScoutCategories: boolean;
};

export const fetchPriceResultsMoreFromCategory = ({
    authToken,
    deployment,
    excludedFacets,
    ipAddress,
    source,
    useScoutCategories,
}: FetchPriceResultsMoreFromCategoryParams) => {
    const searchQuery = getAugmentedSearchQuery(
        buildSearchQuery({
            browseFacetOptionIds: source.creatorId
                ? { [FacetTypes.CREATOR_ID]: [String(source.creatorId)] }
                : undefined,
            pathname: source.viewAllUrl,
            searchPageSize: MORE_FROM_LIMIT + 1,
        }),
        excludedFacets
    );

    return fetchCategoryResults({
        authToken,
        deployment,
        ids: [source.categoryId],
        ipAddress,
        searchQuery,
        skipAggs: true,
        useScoutCategories,
    });
};
